import React from 'react';
import LinkProvider from '../../../CommonComponents/LinkProvider/LinkProvider';

const LinkWithText = props => {
    const { text, url, linkText, styleObj } = props;
    return (<div className={`link-with-text ${styleObj}`}>
        <span className="text-cool_grey">{text}</span>
        <LinkProvider to={url}>{' '}{linkText}</LinkProvider>
    </div>);
};

export default LinkWithText;
